<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{startStage}}"
  end="{{endStage}}"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <app-ion-common-label
    [id]="idLabelCep"
    class="document-type-label1"
    labelStyle="display-rg"
    labelDescription="Qual o seu CEP?"
  >
  </app-ion-common-label>

  <div class="conent-center conent-center--mrt-lg">
    <form [formGroup]="addressCepForm" (ngSubmit)="submitForm($event)">
      <app-ion-common-input
        [fieldValue]="numberCep"
        [placeholder]="placeholder"
        [error]="error"
        [verifyMsgError]="verifyMsgError"
        [id]="idComponentCep"
        [textError]="textError"
        maxLength="9"
        (textChange)="numberCep=$event; verifyCep(); resetAlertHandle($event)"
        type="tel"
        [idLabel]="idLabel"
        [label]="label"
        [disabled]="!this.edit"
        name="addressCep"
        formControlName="addressCep"
        ngDefaultControl
      >
      </app-ion-common-input>
    </form>
  </div>

  <app-ion-common-button
    [id]="idButtonCep"
    class="hidden"
    [ngClass]="{'hidden': !buttonEnable}"
    [attr.aria-hidden]="!buttonEnable"
    label="Continuar"
    (clickButton)="clickNext();"
  ></app-ion-common-button>

  <div class="alert-cep">
    <ids-alert
    [show]="showError"
    (close)="alertLog()"
    icon
    header="Tivemos um problema"
    [closeMessage]="'fechar'"
    variant="error"
  >
    Por favor, tente novamente.
  </ids-alert>
  </div>
</ion-content>
